<template>
  <div class="eligibility-reasons">
    <h3
        v-if="notEligible"
        class="title">
      Not eligible for {{ service }}
    </h3>
    <strong
        v-else>
      Device is eligible for {{ service }}
    </strong>
    <ul class="reasons-list">
      <li
          v-for="(reason, index) in reasons"
          :key="index"
          class="reason-item">
        {{ reason }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "EligibilityReasons",
  props: {
    service: {
      type: String,
      required: true,
      validator: function (value) {
        return ["replacement", "refund", "parts"].includes(
          String(value).toLowerCase()
        );
      },
    },
    reasons: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    notEligible() {
      return this.reasons.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.eligibility-reasons {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  max-width: 500px;
  font-family: sans-serif;

  .title {
    color: #333;
    font-size: 1.1em;
    margin: 0 0 16px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  .reasons-list {
    margin: 0;
    padding: 0;
    list-style: none;

    .reason-item {
      position: relative;
      padding: 8px 0 8px 24px;
      color: #555;
      line-height: 1.4;
      word-break: break-word;

      &:before {
        content: "•";
        position: absolute;
        left: 8px;
        color: #999;
      }

      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
}
</style>
